var _defs, _rect, _g, _text, _rect2, _text2, _rect3, _text3, _text4, _rect4, _text5, _text6, _rect5, _text7, _text8, _path, _path2, _circle, _circle2, _circle3, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYaft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 340",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0b132b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#1c2541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f172a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chartGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10b981",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#10b981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06b6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3b82f6"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.05)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 60,
    x2: 560,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 120,
    x2: 560,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 180,
    x2: 560,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 240,
    x2: 560,
    y2: 240
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 48,
    fill: "#f8fafc",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 20,
    fontWeight: 800,
    letterSpacing: -0.5
  }, "YAFT Financial")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 32,
    width: 90,
    height: 22,
    rx: 11,
    fill: "rgba(6,182,212,0.15)",
    stroke: "rgba(6,182,212,0.3)",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 47,
    fill: "#06b6d4",
    fontFamily: "monospace",
    fontSize: 11,
    fontWeight: 600,
    textAnchor: "middle"
  }, "Next.js 15")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 70,
    width: 150,
    height: 60,
    rx: 8,
    fill: "rgba(255,255,255,0.03)",
    stroke: "rgba(255,255,255,0.08)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 90,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 11
  }, "Net Worth")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 116,
    fill: "#34d399",
    fontFamily: "monospace",
    fontSize: 18,
    fontWeight: 700
  }, "+34.8% YoY")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 70,
    width: 150,
    height: 60,
    rx: 8,
    fill: "rgba(255,255,255,0.03)",
    stroke: "rgba(255,255,255,0.08)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 90,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 11
  }, "Active Ledgers")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 235,
    y: 116,
    fill: "#38bdf8",
    fontFamily: "monospace",
    fontSize: 18,
    fontWeight: 700
  }, "Multi-Account")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 70,
    width: 160,
    height: 60,
    rx: 8,
    fill: "rgba(255,255,255,0.03)",
    stroke: "rgba(255,255,255,0.08)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 90,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 11
  }, "API Documentation")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 116,
    fill: "#fbbf24",
    fontFamily: "monospace",
    fontSize: 18,
    fontWeight: 700
  }, "Swagger REST")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50 250 L 110 220 L 180 230 L 250 180 L 320 190 L 390 150 L 460 165 L 550 120 L 550 280 L 50 280 Z",
    fill: "url(#chartGrad)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 250 L 110 220 L 180 230 L 250 180 L 320 190 L 390 150 L 460 165 L 550 120",
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 180,
    r: 4,
    fill: "#10b981",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 150,
    r: 4,
    fill: "#10b981",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 120,
    r: 5,
    fill: "#10b981",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 315,
    fill: "#64748b",
    fontFamily: "monospace",
    fontSize: 11
  }, "Budgeting Engine \u2022 Cash Flow Analytics \u2022 Transaction Ingestion")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaft);
export default __webpack_public_path__ + "static/media/yaft.ceb5a3e1217690f8861ae8cc720ada08.svg";
export { ForwardRef as ReactComponent };